import React from 'react';
import { ReactComponent as LockIcon } from 'Assets/svg/lock.svg';
import ToolTipWithIcon from '../ToolTipWithIcon';
import './styles.scss';

const FeatureLockedTooltip = props => {
  const {
    featureEnabled = false,
    children,
    className = '',
    iconContent,
    callback,
  } = props;

  return (
    !featureEnabled && (
      <ToolTipWithIcon
        callback={callback}
        className={className}
        Icon={
          iconContent || (
            <div className="lock-wrapper">
              <LockIcon />
            </div>
          )
        }
      >
        {children}
      </ToolTipWithIcon>
    )
  );
};

export default FeatureLockedTooltip;
